import { render, staticRenderFns } from "./LocationEditor.html?vue&type=template&id=b4a50854&scoped=true&external"
import script from "./LocationEditor.vue?vue&type=script&lang=js"
export * from "./LocationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a50854",
  null
  
)

export default component.exports